export default __webpack_public_path__ + "static/media/price_drop.97ae3cbe.svg";